import {Component, OnInit} from '@angular/core';
import {GeliosFieldBaseComponent} from "../gelios-field-base/gelios-field-base.component";
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-gelios-boolean-field',
  templateUrl: './gelios-boolean-field.component.html',
})
export class GeliosBooleanFieldComponent extends GeliosFieldBaseComponent implements OnInit {
  constructor(
    protected translate: TranslateService
  ) {
    super(translate);
  }
}
